export const GenericEvents = {
  HOT_KEY_USE: {
    key: 'HOT_KEY_USE',
    name: 'HotKey Used',
    description: 'User pressed a hot key',
  },
} as const
